import { useQuery } from "@tanstack/react-query";
import type { DBNotification } from "../types";
import {
  HISTORY_KEY,
  INBOX_KEY,
  fetchHistory,
  fetchInbox,
} from "../queryKeys";

/**
 * Inbox tab — live, polled query.
 *
 * Smart polling: refetches every 5 minutes in the background and on
 * window focus, which catches near-realtime events even if the
 * postgres_changes subscription drops (the realtime channel is best-
 * effort; this is the belt-and-braces path).
 */
export function useInbox() {
  return useQuery<DBNotification[]>({
    queryKey:             INBOX_KEY,
    queryFn:              fetchInbox,
    refetchInterval:      300_000, // 5 minutes
    refetchOnWindowFocus: true,
  });
}

/**
 * History tab — lazy query.
 *
 * Only runs when the sheet is open AND the History tab is active — the
 * vast majority of users never open this tab, so we avoid paying the
 * fetch cost on every bell open.
 */
export function useHistory(enabled: boolean) {
  return useQuery<DBNotification[]>({
    queryKey:             HISTORY_KEY,
    queryFn:              fetchHistory,
    enabled,
    refetchOnWindowFocus: false,
  });
}
